export default __webpack_public_path__ + "static/media/element_77.ae758eb0.jpg";